<template>
  <v-simple-table v-if="show" v-bind="$attrs">
    <template #default>
      <thead>
        <tr>
          <th v-if="showName">{{ $t('fresh-vue.JsonDetails.header-name') }}</th>
          <th>{{ $t('fresh-vue.JsonDetails.header-value') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(value, key) in internalJson" :key="key">
          <!-- Name -->
          <td v-if="showName">
            <slot
              name="key"
              v-bind="{
                key: key,
                value: value,
                nested: isNestedObject(value)
              }"
            >
              {{ key }}
            </slot>
          </td>

          <!-- value -->
          <td>
            <slot
              name="value"
              v-bind="{
                key: key,
                value: value,
                nested: isNestedObject(value)
              }"
            >
              <template v-if="isNestedObject(value)">
                <v-container>
                  <json-details v-bind="$attrs" :json="value" dense />
                </v-container>
              </template>
              <template v-else>
                {{ value }}
              </template>
            </slot>
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
  <v-container v-else>
    <v-row justify="center">
      <span>{{ $t('fresh-vue.JsonDetails.no-data') }}</span>
    </v-row>
  </v-container>
</template>

<script>
import JsonDetails from './JsonDetails'

export default {
  name: 'JsonDetails',

  components: {
    JsonDetails
  },

  props: {
    json: {
      type: [String, Object, Array],
      required: false,
      default: null
    }
  },

  computed: {
    internalJson() {
      const json = this.json
      return typeof json === 'string' ? JSON.parse(json) : json
    },

    show() {
      if (Array.isArray(this.internalJson)) {
        return this.internalJson.length > 0
      } else {
        return !!this.internalJson
      }
    },
    showName() {
      return !Array.isArray(this.internalJson)
    }
  },

  methods: {
    isNestedObject(value) {
      return value instanceof Object
    }
  }
}
</script>
